import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PayrollAddHocItemsFilter, PayrollFilter, PayrollState } from "../payroll/payroll.types";
import { payrollApi } from "../payroll/payroll.api";
import { PagedSearchFilter } from "../../app/types";

const initialState: PayrollState = {
    searchResult: {
        items: [],
        total: 0,
    },
    filter: {
        page: 1,
        pageSize: 12,
    },
    searchInprogress: false,
    addHocItems: {
        items: [],
        total: 0,
    },
    addHocItemsFilter: {},
};

export const searchPayrollsAsync = createAsyncThunk(
    "payroll/search",
    async (filter: PayrollFilter, { rejectWithValue }) => {
        try {
            return await payrollApi.search(filter);
        } catch (err) {
            throw rejectWithValue(err);
        }
    }
);

export const searchPayrollAddHocItemsAsync = createAsyncThunk(
    "payroll/searchAddHocItems",
    async (filter: PagedSearchFilter<PayrollAddHocItemsFilter>, { rejectWithValue }) => {
        try {
            return await payrollApi.searchPayrollAddHocItems(filter);
        } catch (err) {
            throw rejectWithValue(err);
        }
    }
);

export const payrollSlice = createSlice({
    name: "payroll",
    initialState,
    reducers: {
        changePayrollFilter: (state, action: PayloadAction<any>) => {
            state.filter = { ...state.filter, ...action.payload };
        },
        changeAddHocItemsFilter: (state, action: PayloadAction<any>) => {
            state.addHocItemsFilter = { ...state.addHocItemsFilter, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchPayrollsAsync.fulfilled, (state, action) => {
                state.searchResult = action.payload;
                state.searchInprogress = false;
            })
            .addCase(searchPayrollsAsync.pending, (state, action) => {
                state.searchInprogress = true;
            })
            .addCase(searchPayrollsAsync.rejected, (state, action) => {
                state.searchInprogress = false;
            })
            .addCase(searchPayrollAddHocItemsAsync.fulfilled, (state, action) => {
                state.addHocItems = action.payload;
                state.addHocItemsInProgress = false;
            })
            .addCase(searchPayrollAddHocItemsAsync.pending, (state, action) => {
                state.addHocItemsInProgress = true;
            })
            .addCase(searchPayrollAddHocItemsAsync.rejected, (state, action) => {
                state.addHocItemsInProgress = false;
            });
    },
});

export default payrollSlice.reducer;

export const { changePayrollFilter, changeAddHocItemsFilter } = payrollSlice.actions;

export const payrollsSelector = (state: RootState) => state.payroll.searchResult.items;
export const payrollsTotalSelector = (state: RootState) => state.payroll.searchResult.total;
export const payrollsFilterSelector = (state: RootState) => state.payroll.filter;
export const payrollsSearchStateSelector = (state: RootState) => state.payroll.searchInprogress;
export const payrollAddHocItemsSelector = (state: RootState) => state.payroll.addHocItems;
export const payrollAddHocItemsFilterSelector = (state: RootState) => state.payroll.addHocItemsFilter;
